import React from 'react'

interface Props {
  className?: string
}

const EyeVisible: React.FC<Props> = ({ className = '' }) => {
  return (
    <svg
      width='16'
      height='14'
      viewBox='0 0 16 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M15.5622 6.54687C15.629 6.6884 15.6637 6.84298 15.6637 6.99951C15.6637 7.15603 15.629 7.31061 15.5622 7.45214C13.8993 10.9713 11.3786 12.7309 8.00004 12.7309C4.62146 12.7309 2.10076 10.9713 0.437866 7.45214C0.371026 7.31061 0.336362 7.15603 0.336362 6.99951C0.336362 6.84298 0.371026 6.6884 0.437866 6.54687C2.10076 3.02949 4.62146 1.26992 8.00004 1.26992C11.3786 1.26992 13.8993 3.02949 15.5622 6.54687ZM1.62439 6.99951C3.10086 3.9808 5.1704 2.53554 8.00004 2.53554C10.8297 2.53554 12.8992 3.9808 14.3757 6.99951C12.8992 10.0182 10.8297 11.4652 8.00004 11.4652C5.17046 11.4652 3.10086 10.0182 1.62439 6.99951Z'
        fill='currentColor'
      />
      <path
        d='M8.00004 9.00024C8.53047 9.00024 9.03916 8.78947 9.41423 8.4144C9.78931 8.03932 10.0001 7.53064 10.0001 7.00021C10.0001 6.46978 9.78931 5.96109 9.41423 5.58602C9.03916 5.21094 8.53047 5.00018 8.00004 5.00018C7.46961 5.00018 6.96092 5.21094 6.58585 5.58602C6.21077 5.96109 6.00001 6.46978 6.00001 7.00021C6.00001 7.53064 6.21077 8.03932 6.58585 8.4144C6.96092 8.78947 7.46961 9.00024 8.00004 9.00024ZM8.00004 7.66688C7.73482 7.66688 7.48047 7.5615 7.29294 7.37396C7.1054 7.18643 7.00001 6.93208 7.00001 6.66686C7.00001 6.40164 7.1054 6.14729 7.29294 5.95976C7.48047 5.77222 7.73482 5.66684 8.00004 5.66684C8.26526 5.66684 8.51961 5.77222 8.70714 5.95976C8.89468 6.14729 9.00007 6.40164 9.00007 6.66686C9.00007 6.93208 8.89468 7.18643 8.70714 7.37396C8.51961 7.5615 8.26526 7.66688 8.00004 7.66688Z'
        fill='currentColor'
      />
    </svg>
  )
}

export default EyeVisible
